import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from "./actions";
import { getAttributesTypesApi } from "../../services/attributes_type.service";
import { AxiosResponse } from 'axios';

export function* GET_ALL_ATTRIBUTES_TYPES() {
    try {
        const response: AxiosResponse<any> = yield call(getAttributesTypesApi);
        if (response.data) {
            yield put({
                type: actions.SET_DATA,
                payload: response.data
            })
        }
    } catch (e) {

    }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.GET_DATA, GET_ALL_ATTRIBUTES_TYPES),
    ])
}
